import { Paper, Stack } from '@mui/material'
import { PreferenceFloatingSelect } from '@/components/Settings/SettingsPreferenceSection'
import { SettingsRowLabelBlock } from '@/components/Settings/settingsRowLabelBlock'
import shared from '@/components/Settings/settingsShared.module.scss'
import { GeneralSettingsSection } from './GeneralSettingsSection'

/**
 * @param {{
 *   title: string,
 *   introKey: string,
 *   paperSingle: string,
 *   rowTitle: string,
 *   rowDescription?: string,
 *   hideDescription?: boolean,
 *   ariaLabel: string,
 *   value: string,
 *   options: { value: string, label: string }[],
 *   onChange: (v: string) => void,
 * }} props
 */
export function GeneralSettingsSelectRowSection({
  title,
  introKey,
  paperSingle,
  rowTitle,
  rowDescription,
  hideDescription,
  ariaLabel,
  value,
  options,
  onChange,
}) {
  return (
    <GeneralSettingsSection title={title} introKey={introKey}>
      <Paper elevation={0} className={paperSingle}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'stretch', sm: 'center' }}
          className={shared.preferenceRowLayout}
        >
          <SettingsRowLabelBlock title={rowTitle} description={rowDescription} hideDescription={hideDescription} />
          <PreferenceFloatingSelect aria-label={ariaLabel} value={value} options={options} onChange={onChange} />
        </Stack>
      </Paper>
    </GeneralSettingsSection>
  )
}
